import { useEffect } from 'react';
import ReactLessonPlay from './lesson-play-by-environment/ReactLessonPlay';
// import { hideChatIcon } from '../../services/IntercomChatService';
import { hideAccessibeChatIcon, showAccessibeChatIcon } from '../../services/AccessibeService';
import LiveChatService from '../../services/LiveChatService';
import { showMicrosoftCopilot } from '../../components/copilot/MicrosoftCopilot';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * Play Lesson Action Container
 */
const defaultProps = {
  open: false,
  handleClose: () => { },
  isPreviewMode: false,
  user: null,
  userProfile: null,
  onLessonFinished: () => { },
  terminologies: {},
  initialPageIndex: 0,
  isPlayable: true,
  createAdditionalComponents: () => null,
  onChatWidgetOpen: () => { },
};
export default function LessonPlay(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const {
    open,
    handleClose,
    lesson,
    isPreviewMode,
    user,
    userProfile,
    terminologies,
    onLessonFinished,
    initialPageIndex,
    isPlayable,
    createAdditionalComponents,
    onChatWidgetOpen,
  } = mergedProps;
  useEffect(() => {
    hideAccessibeChatIcon();
    LiveChatService.hideLiveChatIcon();
    showMicrosoftCopilot(false);
    return () => {
      showAccessibeChatIcon();
      LiveChatService.showLiveChatIcon();
      showMicrosoftCopilot(true);
    };
  }, []);

  return (
    <ReactLessonPlay
      open={open}
      handleClose={handleClose}
      lesson={lesson}
      isPreviewMode={isPreviewMode}
      user={user}
      userProfile={userProfile}
      terminologies={terminologies}
      onLessonFinished={onLessonFinished}
      initialPageIndex={initialPageIndex}
      isPlayable={isPlayable}
      createAdditionalComponents={createAdditionalComponents}
      onChatWidgetOpen={onChatWidgetOpen}
    />
  );
}
